import { colors } from 'shared/styles/colors'
import styled from 'styled-components'
import { Radio } from '@material-ui/core'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 20px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }
`
export const Title = styled.div`
  font-family: 'Roboto';
  font-size: 16px;
  font-weight: 700;
  padding-bottom: 20px;
  color: ${colors.grayDark};
`
export const StyledRadio = styled(Radio)``

export const RadioContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
